/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Action_Unarchive_TitleInputs */

const fr_vehicle_action_unarchive_title = /** @type {(inputs: Vehicle_Action_Unarchive_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Désarchiver ce véhicule`)
};

const en_vehicle_action_unarchive_title = /** @type {(inputs: Vehicle_Action_Unarchive_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unarchive this vehicle`)
};

/**
* | output |
* | --- |
* | "Unarchive this vehicle" |
*
* @param {Vehicle_Action_Unarchive_TitleInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const vehicle_action_unarchive_title = /** @type {((inputs?: Vehicle_Action_Unarchive_TitleInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Action_Unarchive_TitleInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_vehicle_action_unarchive_title(inputs)
	return en_vehicle_action_unarchive_title(inputs)
});